import {
  IWorkLogConfig,
  IWorkLogConfigUpdateRequest,
  updateWorkLogConfig
} from "../../../services/workLogConfig";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG_CONFIG } from "../keys";

export const useMutationUpdateWorkLogConfig = () =>
  useWSMutation<IWorkLogConfig, WSServiceError, IWorkLogConfigUpdateRequest>(
    request => updateWorkLogConfig(request),
    {
      dependencies: [QUERY_WORK_LOG_CONFIG]
    }
  );
